import EChartCustomized, {
    SCHEMES,
    TOOLTIP_OPTIONS,
} from '@/components/EchartCustomized'
import { ContractStatistical } from '@/modules/Contract/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

const CustomerContractDashboard: React.FC<{ data?: ContractStatistical }> = ({
    data,
}) => {
    const { t } = useTranslation()

    const chartData = [
        {
            name: t('total-contract'),
            value: data?.total_count || 0,
        },
        {
            name: t('contract-new'),
            value: data?.created_count || 0,
        },
        {
            name: t('contract-processing'),
            value: data?.exchanging_count || 0,
        },
        {
            name: t('contract-uploading'),
            value: data?.uploading_count || 0,
        },
        {
            name: t('contract-completed'),
            value: data?.active_count || 0,
        },
        {
            name: t('contract-expiried'),
            value: data?.expired_count || 0,
        },
    ]

    const options = {
        tooltip: {
            trigger: 'axis',
            ...TOOLTIP_OPTIONS,
            formatter: function (params: any) {
                return params
                    .map(
                        (p: any) => `
                    <b>${p.name}</b><br/>
                    ${p.seriesName}: ${p.value}
                `
                    )
                    .join('<br/>')
            },
        },
        grid: {
            top: '15%',
            left: '2%',
            right: '2%',
            bottom: '0%',
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            show: false,
            data: chartData.map((d) => d.name),
            axisLabel: {
                rotate: 0,
            },
        },
        yAxis: {
            type: 'value',
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#e0e0e0',
                    type: [3, 3],
                    dashOffset: 3,
                },
            },
        },
        color: SCHEMES.primary,
        series: [
            {
                name: t('contract-statistic'),
                type: 'bar',
                data: chartData.map((d, i) => ({
                    value: d.value,
                    name: d.name,
                    itemStyle: {
                        color: [
                            '#3f51b5', // tổng
                            '#fbc02d', // tạo mới
                            '#fb8c00', // trao đổi
                            '#29b6f6', // upload
                            '#66bb6a', // hoàn tất
                            '#ef5350', // quá hạn
                        ][i],
                    },
                })),
                label: {
                    show: true,
                    position: 'top',
                },
            },
        ],
    }

    return (
        <div className="bg-white rounded-[8px] p-4">
            <Typogaphy
                size="medium"
                className="text-primary font-semibold pb-10"
            >
                {t('contract-statistical')}
            </Typogaphy>
            <div className="m-h-[500px] max-w-full">
                {/* @ts-ignore */}
                <EChartCustomized options={{ ...options }} />
            </div>
            <div className="flex flex-wrap justify-center gap-2 mt-2">
                {chartData.map((item, index) => (
                    <div key={item.name} className="flex items-center gap-2">
                        <div
                            className="w-2 h-2"
                            style={{ backgroundColor: SCHEMES.primary[index] }}
                        ></div>
                        <Typogaphy size="small" className="text-gray-700">
                            {item.name}
                        </Typogaphy>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CustomerContractDashboard
